export default {
  properties: {
    default: { type: 'object' },
    label_singular: { type: 'string' },
    key_label: { type: 'string' },
    value_label: { type: 'string' },
    max: { type: 'number' },
    min: { type: 'number' },
  },
};
